// Angular
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { DragDropModule } from '@angular/cdk/drag-drop';

// Otras Librerias
import { GoogleMapsModule } from '@angular/google-maps';
import { FlexLayoutModule } from '@angular/flex-layout';

// Modulos Propios
import { DialogModule } from './dialog/dialog.module';
import { ColumnSelectModule } from './column-select/column-select.module';
import { FiltroTablaModule } from './filtro-tabla/filtro-tabla.module';
import { MaterialModule } from './material.module';
import { MatPaginatorGotoModule } from './mat-paginator-goto/mat-paginator-goto.module';
import { AutocompleteDireccionModule } from './autocomplete-direccion/autocomplete-direccion.module';
import { UbicarModule } from './ubicar/ubicar.module';
import { ChartModule } from './chart/chart.module';
import { PolygonDrawModule } from './polygon-draw/polygon-draw.module';
import { BreadcrumbsModule } from './breadcrumbs/breadcrumbs.module';
import {
  NgxMatDatetimePickerModule,
  NgxMatNativeDateModule,
  NgxMatTimepickerModule,
} from '@angular-material-components/datetime-picker';
import { TextareaModule } from './textarea/module';
import { MyColorPickerModule } from './color-picker/module';
import { ColorPickerModule } from 'ngx-color-picker';
import { MapaFacilModule } from './mapa-facil/mapa-facil.module';
import { TablaComponent } from './standalone/tabla/tabla.component';
import { DatetimeRangePickerComponent } from './datetime-range-picker/component';
import { NgSelectModule } from '@ng-select/ng-select';

@NgModule({
  imports: [TablaComponent, DatetimeRangePickerComponent],
  exports: [
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    DragDropModule,
    FlexLayoutModule,
    MaterialModule,
    GoogleMapsModule,
    NgxMatDatetimePickerModule,
    NgxMatTimepickerModule,
    NgxMatNativeDateModule,
    MyColorPickerModule,
    ColorPickerModule,
    NgSelectModule,
    //
    ColumnSelectModule,
    DialogModule,
    FiltroTablaModule,
    MatPaginatorGotoModule,
    AutocompleteDireccionModule,
    PolygonDrawModule,
    UbicarModule,
    ChartModule,
    BreadcrumbsModule,
    TextareaModule,
    MapaFacilModule,
    // Componentes
    TablaComponent,
    DatetimeRangePickerComponent,
  ],
})
export class AuxiliaresModule {}
